
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ProductEnquirySelectGrid extends _Ext.GridBase<Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; }
        protected getIdProperty() { return Stock.StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return Stock.StockItemRow.localTextPrefix; }
        protected getService() { return Stock.StockEnquiryService.baseUrl; }
        //protected getInsertPermission() { return Stock.StockItemRow.insertPermission; }
        //protected getUpdatePermission() { return Stock.StockItemRow.updatePermission; }
        //protected getDeletePermission() { return Stock.StockItemRow.deletePermission; }
        protected useViewMode() { return true; }
        items: any[];

        constructor(container: JQuery, options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
            var productcode = options.GridFilters.ProductCode;
            (this.view.params as TransactionRequest).ProductCode = productcode;

             
        }
        private autoSize;
          

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}